module.exports = __webpack_public_path__ + "static/media/career-progress.e12d295a.svg";